import {InWarehouseButtonContainer} from "../styled";
import BarekamText from "../../../components/text";
import BarekamButton, {SidebarButtons} from "../../../components/button";
import Message from "../../../components/message";
import {useAppSelector} from "../../../../redux/store";
import {MessageSections} from "../../../components/message/message";
import {useTheme} from "@mui/material";
import React from "react";

export const NavigationItem = React.memo(({name, onClick, inOrders, itemId, countable}: NavigationItemProps) => {
    const {orderStateId, ordersStateSummary, oldestInWarehouseOrderDate} = useAppSelector(state => state.ordersReducer);
    const theme = useTheme();

    return (
        <BarekamButton onClick={() => onClick()}
                       selected={inOrders && orderStateId === itemId}
                       type={SidebarButtons.ITEM}
                       key={itemId}>
            <div style={{width: countable ? '70%' : '100%'}}>
                {
                    name === 'in_local_warehouse' && ordersStateSummary[itemId] > 0
                        ? <InWarehouseButtonContainer>
                            <BarekamText variant={"m"}>
                                <Message messageKey={name} sectionId={MessageSections.MAIN}/>
                            </BarekamText>

                            {/*{oldestInWarehouseOrderDate*/}
                            {/*    ? <SidebarTimeChip label={moment(oldestInWarehouseOrderDate).fromNow()}/>*/}
                            {/*    : <></>*/}
                            {/*}*/}
                        </InWarehouseButtonContainer>
                        : <BarekamText variant={"m"}>
                            <Message messageKey={name} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                }
            </div>

            {countable
                ? <div style={{color: inOrders && orderStateId === itemId ? '#ff' : theme.barekam.sidebar.textCount}}>
                    <BarekamText variant={"m"} align={"right"}>
                        {ordersStateSummary[itemId] || 0}
                    </BarekamText>
                </div>
                : ''
            }
        </BarekamButton>
    )
});

interface NavigationItemProps {
    name: string,
    onClick: () => void,
    itemId: string | number,

    inOrders: boolean,
    countable?: boolean,
}